import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "BlueCross BlueShield of Tennessee",
  shortName: "BCBS Tennessee",
  slug: "bcbst-insurance",
  seoTitle:
    "BlueCross BlueShield of Tennessee TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how BlueCross BlueShield of Tennessee policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBS Tennessee TMS coverage, BlueCross BlueShield Tennessee SPRAVATO authorization, BCBST mental health benefits Coral Springs FL, BCBS Tennessee depression treatment Florida",
};

export const BcbstInsurance = () => <InsurancePageTemplate config={config} />;
export default BcbstInsurance;
